// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"1cd3c50a","461":"3e3459ee","636":"cf08cb61"}[chunkId] + ".chunk.css";
};